


    <section class="container-fluid mt-5">
        <h2>Todos los usuarios</h2>
        
        <div class="row">
            <div class="col-12">
        <table class="table mt-3">
    
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Nombre</th>

                    <th>Correo</th>
                   <th>Usuario</th>
                   <th>Contraseña</th>
                   <th>Celular</th>
                   <th>Ver Perfil</th>
                    <th>Borrar</th>
                </tr>
        
        
        
            </thead>
            <tbody>
              
                <tr *ngFor = "let usuario of usuarios">
                    <td>{{usuario?.numeroDocumento}}</td>
                    <td> {{usuario?.nombre }}</td> 
                    <td>{{usuario?.correo}}</td>
                    <td> {{usuario?.usuario }}</td>
                    <td>{{usuario?.contrasena}}</td>
                    <td>{{usuario?.celular}}</td>
                    <td class="td-user"><button  class="btn btn-warning" routerLink="usuario/admin/{{usuario.usuario}}" > Ver Perfil</button></td>
                    <td><button  class="btn btn-danger" (click)="deleteUsuario(usuario?.numeroDocumento)" > Delete</button></td>
                </tr>
        
        
            </tbody>
        
        </table>
    </div>
    </div>
    
    </section>